export class ExtendableError extends Error {
  public constructor(message: string, cause?: Error, cause2?: Error) {
    super(message);

    this.name = this.constructor.name;

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(message).stack;
    }

    if (cause && cause.stack) {
      this.stack = `${this.stack}\n\nCause: ${cause.stack}`;
    }

    if (cause2 && cause2.stack) {
      this.stack += `${this.stack}\n\nCause 2: ${cause2.stack}`;
    }
  }
}
